<template>
  <div class="footer-box mt-10">
    <div v-if="!islogRoute" class="footer-wrap container">
      <div class="foot_top flex-row">
        <div class="footer-title">
          <div class="imgdiv">
            <!-- <img
                src="../../assets/images/foot.png"
                alt="" /> -->
            <div class="img">{{ $t("广") }}</div>
          </div>
          <div style="color: #24a2ff">{{ $t("汽配展贸") }}</div>
        </div>
        <div class="footer-title">
          <div class="imgdiv">
            <div class="img">{{ $t("汇") }}</div>
          </div>
          <div style="color: #24a2ff">{{ $t("实力工厂") }}</div>
        </div>
        <div class="footer-title">
          <div class="imgdiv bortest">
            <div class="img">{{ $t("保") }}</div>
          </div>
          <div style="color: #24a2ff">{{ $t("品质保证") }}</div>
        </div>
        <div class="footer-title">
          <div class="imgdiv">
            <div class="img">{{ $t("销") }}</div>
          </div>
          <div style="color: #24a2ff">{{ $t("汽配出海") }}</div>
        </div>
      </div>

      <el-row
        :gutter="30"
        type="flex"
        style="flex-wrap: wrap"
        class="footer-flex"
      >
        <el-col :span="4" class="">
          <div class="footer-flex-item">
            <div class="footer-msg">
              <div class="footer-msg-item fw-b">{{ $t("账号管理") }}</div>
            </div>
            <div class="footer-msg">
              <div class="footer-msg-item">
                <a href="javascript:;">{{ $t("账户注册") }}</a>
              </div>
            </div>
            <div class="footer-msg botest">
              <div class="footer-msg-item">
                <a href="javascript:;">{{ $t("信息维护") }}</a>
              </div>
            </div>
            <div class="footer-msg">
              <div class="footer-msg-item">
                <a href="javascript:;">{{ $t("安全隐私") }}</a>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="footer-flex-item">
            <div class="footer-msg">
              <div class="footer-msg-item fw-b">{{ $t("采购指南") }}</div>
            </div>
            <div class="footer-msg">
              <div class="footer-msg-item">
                <a href="javascript:;">{{ $t("平台简介") }}</a>
              </div>
            </div>
            <div class="footer-msg">
              <div class="footer-msg-item">
                <a href=" javascript:;">{{ $t("采购流程") }}</a>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="footer-flex-item">
            <div class="footer-msg">
              <div class="footer-msg-item fw-b">{{ $t("物流配送") }}</div>
            </div>
            <div class="footer-msg">
              <div class="footer-msg-item">
                <a href="javascript:;">{{ $t("配送方式") }}</a>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="footer-flex-item">
            <div class="footer-msg">
              <div class="footer-msg-item fw-b">{{ $t("售后服务") }}</div>
            </div>
            <div class="footer-msg">
              <div class="footer-msg-item">
                <a href="javascript:;">{{ $t("售后政策") }}</a>
              </div>
            </div>
            <div class="footer-msg">
              <div class="footer-msg-item">
                <a href="javascript:; ">{{ $t("退货流程及规则") }}</a>
              </div>
            </div>
            <div class="footer-msg">
              <div class="footer-msg-item">
                <a href="javascript:; ">{{ $t("联系我们") }}</a>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <!-- 图片 -->
          <div class="imgList flex-row mt-20 ml-10">
            <div class="mr-30">
              <img src="../../assets/images/erweima.jpg" alt="" />
            </div>
            <div><img src="../../assets/images/erweima2.png" alt="" /></div>
          </div>
          <div class="p-10 fs-12" style="color: #c3c3c3;width: 246px;">
            {{ $t("扫一扫关注官方公众号和小程序") }}
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="mt-20" style="border-top: 1px solid #cdcdcd"></div>
    <div class="footer-bottom bortest">
      <span>{{ $t("关于广园汇") }}</span>
      <span style="margin: 0 10px">|</span>
      <RouterLink to="/aboutUs">{{ $t("联系方式") }}</RouterLink>
      <div class="footer-link container pb-10">
        <div>Copyright @ 2024-{{ $t("东莞广园汇供应链有限公司") }} ALLRight Reserved</div>
        <a href="https://beian.miit.gov.cn">{{ $t("粤ICP备2024268269号-1") }}</a>
        <!-- <div>{{ $t("粤ICP备2024268269号-1") }}</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { RouterLink } from "vue-router";

export default {
  data() {
    return {};
  },
  methods: {
    gotoContact() {
      this.$router.push({
        path: "/contact",
      });
    },
    /** 跳转到关于我们 */
    gotoAboutUs() {
      this.$router.push({
        path: "/aboutUs",
      });
    },
    /** 跳转到Q&A */
    gotoQA() {
      this.$router.push({
        path: "/qAndA",
      });
    },
    /** 跳转到协议 */
    gotoAgreement(type) {
      if (this.$route.query.type !== type) {
        this.$router.push({
          path: "/agreement",
          query: {
            type: type,
          },
        });
      }
    },
  },
  computed: {
    islogRoute() {
      return (
        this.$route.path === "/login" ||
        this.$route.path === "/register" ||
        this.$route.path === "/resetPassword"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-box {
  width: 100%;
  height: auto;
  padding-bottom: 75px;

  .foot_top {
    justify-content: center;
    width: 65%;
    margin: 0 auto;
    padding-top: 50px;

    .footer-title {
      width: 100%;
      line-height: 30px;
      font-size: 16px;
      font-weight: bolder;
      display: flex;
      flex-direction: column;
      align-items: center;

      .imgdiv {
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        border: 3px solid #24a2ff;
      }

      .img {
        color: #24a2ff;
        font-weight: 900;
      }
    }
  }

  .footer-wrap {
    background: white;
    margin: 0 auto;
    // border-bottom: 1px solid #CDCDCD;
    padding: 0 15px;
  }

  .footer-flex {
    height: auto;
    padding: 0 0 46px;

    .footer-flex-item {
      // padding-top: 50px;
    }

    .footer-title {
      width: 100%;
      line-height: 30px;
      font-size: 16px;
      font-weight: bolder;
      display: flex;
      flex-direction: column;
      align-items: center;

      .imgdiv {
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        border: 3px solid #24a2ff;
      }

      .img {
        color: #24a2ff;
        font-weight: 900;
      }
    }

    .footer-msg {
      height: auto;
      display: flex;
      align-items: center;
      margin-top: 28px;

      .footer-msg-item {
        flex: 1;
        line-height: 22px;
        font-size: 15px;
        margin: 0 auto;
        text-align: center;

        a {
          color: #8b8888;
        }
      }
    }

    .footer-text {
      width: 100%;
      line-height: 22px;
      font-size: 15px;
      margin-top: 25px;
      padding-bottom: 8px;
      box-sizing: border-box;
      word-break: break-all;
      word-wrap: break-word;
    }
    .imgList {
      width: 100%;

      img {
        width: 95px;
        height: 95px;
      }
    }
  }

  .footer-logo {
    width: 183px;
    height: 45px;
    display: block;
    margin: 26px auto 8px;
  }

  .footer-bottom {
    background-color: #184d7f;
    color: #c3c3c3;
    width: 100%;
    line-height: 18px;
    font-size: 15px;
    text-align: center;
    padding-top: 20px;

    a {
      color: #c3c3c3;
    }

    .iconfont {
      vertical-align: middle;
    }

    .big {
      font-size: 17px;
    }
  }

  .footer-link {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    padding-top: 35px;

    .footer-link-item {
      width: auto;
      line-height: 20px;
      cursor: pointer;
    }
  }
}
</style>